import { TSearchState } from "./search.types";
import { PRODUCTS_PER_PAGE } from "../../constants/search";

export const initialState: TSearchState = {
  products: [],
  displayCount: PRODUCTS_PER_PAGE,
  isLoading: false,
  error: null,
  lastSearchQuery: null,
};
